import {action, isObservableArray, makeObservable, toJS} from 'mobx';

export default class BaseModel {
  store;

  constructor(store) {
    if (!store) {
      this.store = store;
    }
    makeObservable(this, {
      toJson: action,
      fromJson: action,
      setProperty: action,
      togglePropertyOptions: action
    })
  }

  toJson() {
  const data = {};

  Object.keys(this).forEach((k) => {
    if (k === "store") return;

    const item = this[k];

    if (item === undefined) return;

    // observable array
    if (isObservableArray(item)) {
      const arr = item.slice(); // ✅ non-mutating copy
      data[k] = arr.map((x) => (x instanceof BaseModel ? x.toJson() : toJS(x)));
      return;
    }

    // nested model
    if (item instanceof BaseModel) {
      data[k] = item.toJson();
      return;
    }

    // plain objects (MobX observable objects etc.)
    if (item && typeof item === "object") {
      data[k] = toJS(item);
      return;
    }

    // primitive
    data[k] = item;
  });

  return data;
}

  parseKgDateTime(s) {
    // supports: "15.02.2026 10:30" and "15.02.2026"
    if (typeof s !== "string") return null;
    const str = s.trim();

    const m = str.match(/^(\d{2})\.(\d{2})\.(\d{4})(?:\s+(\d{2}):(\d{2}))?$/);
    if (!m) return null;

    const dd = Number(m[1]);
    const mm = Number(m[2]) - 1;
    const yyyy = Number(m[3]);
    const HH = m[4] != null ? Number(m[4]) : 0;
    const MI = m[5] != null ? Number(m[5]) : 0;

    const d = new Date(yyyy, mm, dd, HH, MI, 0, 0);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  fromJson(data) {
    if (!data) return;
  
    Object.keys(data).forEach(k => {
      if (k !== "store" && this.hasOwnProperty(k)) {
        let value = data[k];
      
        if (/(date|time|_at)$/i.test(k) && value) {
          // 1) try your backend format first
          const parsed = this.parseKgDateTime(value);
          // 2) fallback to native parsing (ISO strings etc.)
          value = parsed || new Date(value);
        }
      
        this[k] = value;
      }
    });
  }

  setProperty(key, value) {
    this[key] = value;
  }

  togglePropertyOptions(prop, option) {
    if (!this[prop]) {
      this[prop] = [];
    }
    if (this[prop].includes(option)) {
      this[prop] = this[prop].filter((item) => item !== option);
    } else {
      this[prop] = [...this[prop], option];
    }
  }
  

}
